import React, { useContext, useEffect } from 'react'
import PageLoader from 'Lib/Pageloader'
import TripsList from 'AccountsContainers/Trips/TripList'
import { TripState } from 'AccountsContainers/Trips/context'
import { AccountsContext } from 'AccountsContext'
import Legal from 'AccountsContainers/Legal'
import { LegalState } from 'AccountsContainers/Legal/context'
import { AccountState } from 'AccountsContainers/Account/context'
import Account from 'AccountsContainers/Account'
import { ACCOUNTS_PAGE_HEADER } from 'AccountsConstants/language/account'
import { CLEVERTAP_EVENT_NAME, CLEVERTAP_PLATFORM } from 'AccountsConstants/clevertap'
import Login from 'AccountsContainers/Login'
import Logout from 'AccountsContainers/Logout'
import NoTripAvailable from 'AccountsContainers/Trips/NoTripAvailable'
import { triggerClevertap } from 'AccountsUtils'

const AccountHome = props => {
  const {
    handleAccountsHeaderChange,
    handleUpdateBackButton,
    isLoggedIn,
    checkSignIn,
    accountsLoading
  } = useContext(AccountsContext)
  useEffect(() => {
    if (!isLoggedIn) {
      checkSignIn()
    }
  }, [])
  useEffect(() => {
    handleAccountsHeaderChange({ header: ACCOUNTS_PAGE_HEADER, subHeader: '' })
    handleUpdateBackButton(false)
    const clevertapData = {
      'event type': 'profile page loaded',
      platform: CLEVERTAP_PLATFORM,
      'logged in': isLoggedIn
    }
    triggerClevertap(CLEVERTAP_EVENT_NAME, clevertapData)
  }, [])

  let accountsPage
  if (accountsLoading) {
    accountsPage = (
      <PageLoader
        title="Fetching your profile"
        message="Please wait while we load your profile"
      />
    )
  } else {
    accountsPage = (
      <div>
        <If condition={!isLoggedIn}>
          <Login />
          <NoTripAvailable />
        </If>

        <If condition={isLoggedIn}>
          <TripState>
            <TripsList />
          </TripState>
        </If>

        <AccountState>
          <Account loggedIn={isLoggedIn} />
        </AccountState>

        <LegalState>
          <Legal />
        </LegalState>

        <If condition={isLoggedIn}>
          <Logout />
        </If>
      </div>
    )
  }

  return (
    <React.Fragment>
      {accountsPage}
    </React.Fragment>
  )
}

export default AccountHome
